module.exports = __webpack_public_path__ + "img/addbk5.68e22621.png";